/**
 * Training Units Data Module
 *
 * Purpose: Contains detailed training unit specifications
 * Data Source: fss_training_units_detail.csv
 * Usage: Results display, course recommendations
 */

const trainingUnits = {
  SITXFSA005: {
    code: 'SITXFSA005',
    name: 'Use hygienic practices for food safety',
    industrySector: 'Hospitality',
    level: 'Level 1',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  },
  SITXFSA006: {
    code: 'SITXFSA006',
    name: 'Participate in safe food handling practices',
    industrySector: 'Hospitality',
    level: 'Level 2',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  },
  SIRRFSA001: {
    code: 'SIRRFSA001',
    name: 'Handle food safely in a retail environment',
    industrySector: 'Retail',
    level: 'Level 1',
    durationHours: 8,
    assessmentType: 'Online theory + workplace practical'
  },
  HLTFSE001: {
    code: 'HLTFSE001',
    name: 'Follow basic food safety practices',
    industrySector: 'Health & Community',
    level: 'Level 1',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  },
  HLTFSE005: {
    code: 'HLTFSE005',
    name: 'Apply and monitor food safety requirements',
    industrySector: 'Health & Community',
    level: 'Level 2',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  },
  HLTFSE007: {
    code: 'HLTFSE007',
    name: 'Oversee the day-to-day implementation of food safety in the workplace',
    industrySector: 'Health & Community',
    level: 'Level 2',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  },
  FBPFSY1002: {
    code: 'FBPFSY1002',
    name: 'Follow work procedures to maintain food safety',
    industrySector: 'Food Processing',
    level: 'Level 1',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  },
  FBPFSY2002: {
    code: 'FBPFSY2002',
    name: 'Apply food safety procedures',
    industrySector: 'Food Processing',
    level: 'Level 2',
    durationHours: 2,
    assessmentType: 'Online theory + workplace practical'
  }
};

export default trainingUnits;
